<!--
  Each state carries its own SHAPE, not just its own colour: check, cross and query. The mark is
  decorative because the state is written out beside it, but it must still differentiate without
  colour for the same reason.

  No evidence date here. It backs the claim in admin; on the public sheet it would turn a
  statement of fact into an audit trail the guest is asked to judge.
-->
<ul class="product-facts">
    @for (fact of rendered(); track fact.key) {
        <li class="product-fact" [class]="'state-' + fact.value">
            <span class="fact-mark" aria-hidden="true">
                @switch (fact.value) {
                    @case ('true') {
                        <svg viewBox="0 0 22 22" width="20" height="20" fill="none">
                            <path d="M6 11.4 9.6 15l6.4-7" stroke="currentColor" stroke-width="2.1"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    @case ('false') {
                        <svg viewBox="0 0 22 22" width="20" height="20" fill="none">
                            <path d="M6.5 6.5 15.5 15.5M15.5 6.5 6.5 15.5" stroke="currentColor"
                                  stroke-width="2.1" stroke-linecap="round"/>
                        </svg>
                    }
                    @default {
                        <svg viewBox="0 0 22 22" width="20" height="20" fill="none">
                            <path d="M8 8.4c0-1.9 1.5-3 3.2-3 1.8 0 3.1 1.1 3.1 2.8 0 2.3-3 2.3-3 4.6"
                                  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            <circle cx="11.2" cy="16.4" r="1.25" fill="currentColor"/>
                        </svg>
                    }
                }
            </span>

            <span class="fact-label">{{ fact.label }}</span>
            <span class="fact-value">{{ fact.valueLabel }}</span>
        </li>
    }
</ul>
